export default {
    /**
     * 用户当前是否登录
     */
    isLogin: false,

    /**
     * 侧边栏是否处于扩展状态
     * true : 侧边栏扩展正常显示
     * false : 侧边栏缩进为简易模式
     */
    asideIsExpend: true,

    /**
     * 搜索栏隐藏或显示
     */
    searchShowHidden : true ,


}